export enum CorrectionEngineAlgorithm {
    Simple = 1,
    External = 2,
    AverageBetweenHitsAndQuestions = 3
}
